import summaryCommonStore from "@/store/summaryCommon.store";
import { useEffect, useMemo } from "react";
import SpeakerSummaryItem from "./SpeakerItem";
import summarySpeakerStore from "@/store/summarySpeaker.store";
import SummaryEmtpyTip from "@/assets/summary/ic_speakers_empty.svg?react";
import summarySrcStore from "@/store/summarySrc.store";
import { message } from "antd";
import recordStore from "@/store/record.store";
import IC_NONE from "@/assets/record/ic_none.png";
import SummarySkeleton from "../SummarySkeleton";

export const SPEAKER_ITEM_ID_PREFIX = "speaker-item-";

const SpeakerSummary = () => {
  const summaryEditing = summaryCommonStore((state) => state.summaryEditing);
  const speakerSummary = summarySpeakerStore((state) => state.speakerSummary);
  const newSpeakerSummary = summarySpeakerStore((state) => state.newSpeakerSummary);
  const avatarMap = summaryCommonStore((state) => state.avatarMap);
  const registryAvatar = summaryCommonStore((state) => state.getAvatar);
  const detailInfo = summarySrcStore((state) => state.detailInfo);
  const streamId = summaryCommonStore((state) => state.streamId);
  const retryStatus = summaryCommonStore((state) => state.retryStatus);
  const speakerLoading = summarySpeakerStore((state) => state.speakerLoading);
  const isRetrying = retryStatus === 1;
  const currentSpeakerSummary = useMemo(() => speakerSummary?.srcSpeakers || speakerSummary?.srcSpeakers, [speakerSummary]);
  const renderingSpeakerSummary = useMemo(() => (summaryEditing ? newSpeakerSummary : currentSpeakerSummary), [summaryEditing, newSpeakerSummary, currentSpeakerSummary]);
  const records = recordStore((state) => state.records);
  const setLastSpeakerSummary = summarySpeakerStore((state) => state.setLastSpeakerSummary);
  const fetchSpeakerSummary = summarySpeakerStore((state) => state.fetchSpeakerSummary);

  const retryFetching = async (params: { streamName: string; reload: boolean; contentStep: string; cover: boolean }) => {
    setLastSpeakerSummary(summarySpeakerStore.getState().speakerSummary);
    await fetchSpeakerSummary(params);
  };

  const handleRetry = async () => {
    const currentId = summaryCommonStore.getState().streamId;
    if (!detailInfo?.completeDocFinish) {
      message.warning("重新生成中，请稍后重试");
      return;
    }
    if (retryStatus === 1) {
      message.warning("重新生成中，请稍后重试");
      return;
    }
    // setRetryStatus(1);
    summarySpeakerStore.getState().setSpeakerLoading(true);
    const params = {
      streamName: `live/${streamId}`,
      reload: true,
      contentStep: "SRC_DOC",
      cover: true,
    };
    try {
      await retryFetching(params);
      if (currentId !== summaryCommonStore.getState().streamId) return;
      summarySpeakerStore.getState().setSpeakerLoading(false);
    } catch (e) {
      summarySpeakerStore.getState().setSpeakerLoading(false);
    }
  };

  useEffect(() => {
    if (summaryEditing) {
      const dom = document.getElementById(SPEAKER_ITEM_ID_PREFIX + 0) as HTMLTextAreaElement;
      dom?.focus();
      dom?.setSelectionRange(dom.value.length, dom.value.length);
    }
  }, [summaryEditing]);

  return (
    <div className="flex flex-col gap-8">
      {isRetrying || speakerLoading ? (
        <SummarySkeleton />
      ) : (
        <>
          {records.length === 0 ?
            <div className="flex flex-col flex-justify-center flex-items-center mt-36">
              <img src={IC_NONE} className="w-20 h-20" />
              <span className="mt-1 text-mx-quaternary text-3.5">暂无总结</span>
            </div>
            : !renderingSpeakerSummary || renderingSpeakerSummary?.length === 0 ? (
              <div className="flex flex-col items-center mt-14">
                <SummaryEmtpyTip className="w-60 h-37" />
                <span className="color-#A1A7B2 text-3.5 mt-4">发言人观点提炼，高效回顾重要意见</span>
                <div className="mt-4 rounded-2.5 py-1.5 px-4 bg-#4981F2 text-3.5 color-#fff cursor-pointer" onClick={handleRetry}>
                  开始总结
                </div>
              </div>
            ) : (
              renderingSpeakerSummary?.map((speaker, index) => (
                <SpeakerSummaryItem
                  key={speaker.roleName + index}
                  info={speaker}
                  index={index}
                  avatarSrc={avatarMap.get(speaker.roleName) || registryAvatar(speaker.roleName)}
                  id={SPEAKER_ITEM_ID_PREFIX + index}
                />
              ))
            )}
        </>
      )}
    </div>
  );
};

export default SpeakerSummary;
